<template>
  <div class="title-wrapper">
    <div class="custom-title">{{ title }}</div>
    <div class="custom-subtitle">{{ subtitle }}</div>
  </div>
</template>

<script>
export default {
  props: {
    title: String,
    subtitle: String,
  }
};
</script>

<style scoped>
.custom-subtitle {
  font-size: 1rem;
  font-style: italic;
  margin-top: -25px;
}

.custom-title {
  font-size: calc(1.5rem + 1.25vw) !important;
  text-transform: uppercase; /* Override Bulma */
  font-weight: 400 !important; /* Override Bulma */

  font-family: BlinkMacSystemFont, -apple-system, Segoe UI, Roboto, Oxygen, Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, Helvetica, Arial, sans-serif;
  margin-bottom: 1rem;
}

.title-wrapper {
  width: 100%;
  min-height: 7rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
</style>